import React, {Component} from 'react';
import {Row, Col, Grid} from "react-bootstrap";
import Links from "../../../../utilities/linksConfig/Links";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import EkipaService from "../ekipy/definicjaEkipy/EkipyService";
import KierowcyEkipaCompontent from "./components/KierowcyEkipaCompontent";
import PojazdyEkipaCompontent from "./components/PojazdyEkipaCompontent";
import PojazdyService from "../pojazdy/PojazdyService";
import KierowcyService from "../kierowcy/KierowcyService";
import PolaczenieEkipIPojazdowService from "../ekipy/polaczenieEkipIPojazdow/PolaczenieEkipIPojazdowService";
import EkipyKierowcyService from "../ekipy/polaczenieEkipy/EkipyKierowcyService";
import ReactNotify from 'react-notify';
var tinycolor = require("tinycolor2");

export default class EkipaContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ekipa:null,
            kierowcyWEkipie:[],
            pojazdyWEkipie:[],
            kierowcy:[],
            pojazdy:[],
        };
        this.renderDaneEkipy = this.renderDaneEkipy.bind(this)
        this.onClickDodajNowegoKierowce = this.onClickDodajNowegoKierowce.bind(this)
        this.onClickEdytujKierowce = this.onClickEdytujKierowce.bind(this)
        this.onClickUsunKierowce = this.onClickUsunKierowce.bind(this)
        this.onClickDodajPojazd = this.onClickDodajPojazd.bind(this)
        this.onClickEdytujPojazd = this.onClickEdytujPojazd.bind(this)
        this.onClickUsunPojazd = this.onClickUsunPojazd.bind(this)
    }

    componentDidMount(){
        this.pobierzEkipe()
        this.pobierzPojazdy()
        this.pobierzKierowcow()
    }

    pobierzPojazdy(){
        PojazdyService.getPojazdy().then(function (response) {

            let arr = Array.from(response.data.content,item=>{
                return{
                    ...item,
                    pojazdInfo: item.marka+' '+item.model+' '+item.nrRej
                }
            })

            this.setState({pojazdy:arr})
        }.bind(this))
    }

    pobierzKierowcow(){
        KierowcyService.getKierowcy().then(function (response) {

            let arr = Array.from(response.data,item=>{
                return{
                    ...item,
                    imieNazwisko: item.imie+' '+item.nazwisko,
                    kierowcaInfo: item.imie+' '+item.nazwisko+' '+item.pesel
                }
            })

            this.setState({kierowcy:arr})
        }.bind(this))
    }

    pobierzEkipe(){
        EkipaService.getEkipa(this.props.match.params.ekipaId).then(function (response) {
            this.setState({ekipa:response.data})
            if(Boolean(response.data)){
                this.pobierzKierowcowWEkipie(response.data.idEk)
                this.pobierzPojazdyWEkipie(response.data.idEk)
            }
        }.bind(this))
    }

    pobierzKierowcowWEkipie(id){

        EkipyKierowcyService.getKierWEkipie(id).then(function (response) {
            this.setState({
                kierowcyWEkipie:response.data
            })
        }.bind(this))
    }

    pobierzPojazdyWEkipie(id){

        PolaczenieEkipIPojazdowService.getPojWEkipie(id).then(function (response) {
            this.setState({
                pojazdyWEkipie:response.data
            })
        }.bind(this))
    }


    onClickDodajNowegoKierowce(obj){
        EkipyKierowcyService.addEkipaKier(obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie dodano kierowcę do ekipy', "", 3000)
                this.pobierzKierowcowWEkipie(this.state.ekipa.idEk)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas dodawania połączenia', "", 3000)
            }
        }.bind(this))
    }

    onClickEdytujKierowce(obj){
        EkipyKierowcyService.editEkipaKier(obj.idEkk,obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie edytowano zmianę', "", 3000)
                this.pobierzKierowcowWEkipie(this.state.ekipa.idEk)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas edycji zmiany', "", 3000)
            }
        }.bind(this))
    }

    onClickUsunKierowce(obj){
        EkipyKierowcyService.deleteEkipaKier(obj.idEkk).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie usunięto kierowcę z ekipy', "", 3000)
                this.pobierzKierowcowWEkipie(this.state.ekipa.idEk)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas usuwania połączenia', "", 3000)
            }
        }.bind(this))
    }

    onClickDodajPojazd(obj){
        PolaczenieEkipIPojazdowService.addEkipaPoj(obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie dodano pojazd do ekipy', "", 3000)
                this.pobierzPojazdyWEkipie(this.state.ekipa.idEk)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas dodawania połączenia', "", 3000)
            }
        }.bind(this))
    }

    onClickEdytujPojazd(obj){
        PolaczenieEkipIPojazdowService.editEkipaPoj(obj.idEkp,obj).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie edytowano zmianę', "", 3000)
                this.pobierzPojazdyWEkipie(this.state.ekipa.idEk)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas edycji zmiany', "", 3000)
            }
        }.bind(this))
    }

    onClickUsunPojazd(obj){
        PolaczenieEkipIPojazdowService.deleteEkipaPoj(obj.idEkp).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success('Pomyślnie usunięto pojazd do ekipy', "", 3000)
                this.pobierzPojazdyWEkipie(this.state.ekipa.idEk)
            }
            else {
                this.refs.notificator.error('Wystąpił błąd podczas usuwania połączenia', "", 3000)
            }
        }.bind(this))
    }

    renderDaneEkipy(){
        let color = 'grey';

        if((tinycolor(this.state.ekipa.kolor)).isDark()){
            color = '#ffffff'
        }
        if((tinycolor(this.state.ekipa.kolor)).isLight()){
            color = '#000000'
        }

        return(
            <div>
                <h3>
                    <span className={'label label-default'} style={{background:this.state.ekipa.kolor,color:color}}>{this.state.ekipa.kodEk}</span>
                    <span className={'label label-default'} style={{background:'transparent',color:'#333'}}>
                        {this.state.ekipa.nazwaEk} <span style={{fontWeight:'normal'}}> - Zasoby ekipy</span>
                    </span>
                </h3>
            </div>
        )
    }

    render() {
       return (
           <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                             collapsedLinks={this.props.collapsedLinks}
                             handleClickToogleSidebar={(module)=>this.props.handleClickToogleSidebar(module)}>
               <Grid fluid={true} id={'EkipyContainer'}>
                   <ReactNotify ref='notificator'/>
                   <Row>
                       <Col sm={12}>
                           <div id="subheader">
                               <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                   addressUrl: '/konfiguracja/zarzadzanie-zasobami',
                                   text: 'Zarządzanie zasobami'
                               }, {addressUrl: '/konfiguracja/zarzadzanie-zasobami/ekipy', text: 'Ekipy'},
                                   {addressUrl: '', text: Boolean(this.state.ekipa)?this.state.ekipa.kodEk:''}]}/>
                               <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz} history={this.props.history}/>
                           </div>
                       </Col>
                       <Col sm={12}>
                           <div style={{marginTop:'15px'}}>
                               {
                                   Boolean(this.state.ekipa===null)?
                                       <span><i className={'fa fa-cog fa-spin'}></i> trwa ładowanie danych</span>
                                       :
                                       <div>
                                           {this.renderDaneEkipy()}
                                           <Row>
                                               <Col xs={12} lg={6}>
                                                   <KierowcyEkipaCompontent ekipa={this.state.ekipa} kierowcy={this.state.kierowcy} kierowcyWEkipie={this.state.kierowcyWEkipie}
                                                                            handleClickDodaj={this.onClickDodajNowegoKierowce}
                                                                            handleClickEdytuj={this.onClickEdytujKierowce}
                                                                            handleClickUsun={this.onClickUsunKierowce}
                                                   />
                                               </Col>
                                               <Col xs={12} lg={6}>
                                                   <PojazdyEkipaCompontent ekipa={this.state.ekipa} pojazdy={this.state.pojazdy} pojazdyWEkipie={this.state.pojazdyWEkipie}
                                                                           handleClickDodaj={this.onClickDodajPojazd}
                                                                           handleClickEdytuj={this.onClickEdytujPojazd}
                                                                           handleClickUsun={this.onClickUsunPojazd}
                                                   />
                                               </Col>
                                           </Row>
                                       </div>
                               }
                           </div>
                       </Col>
                   </Row>
               </Grid>
           </SidebarComponent>
            );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/ekipa/EkipaContainer.js